import { IFormArr } from '@/components/types'

export const basicFormConfig: IFormArr = {
  iForms: [
    {
      formItems: [
        {
          label: '申请资源数量',
          field: 'applyResourcesNum',
          type: 'number',
          maxLength: 10,
          placeholder: '请输入申请资源数量'
        },
        {
          label: '承接资源微信号',
          field: 'wechatNo',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入承接资源微信号'
        }
      ]
    },
    {
      formItems: [
        {
          label: '企业微信号',
          field: 'corpWechatNo',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入企业微信号'
        },
        {
          label: '账号ID',
          field: 'account',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入账号ID'
        },
        {
          label: '企微主体',
          field: 'corpId',
          type: 'select',
          filterable: true,
          placeholder: '请选择主体'
        }
      ]
    },
    {
      formItems: [
        {
          label: '申请说明',
          type: 'alltextarea',
          field: 'applyDesc',
          multiple: true,
          placeholder: '请输入申请说明'
        },
        {
          label: '备注',
          field: 'remark',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入备注',
          rows: 2
        }
      ]
    },
    {
      formItems: [
        {
          label: '上传企微二维码',
          field: 'upload',
          type: 'slot'
        },
        {
          label: '上传个微二维码',
          field: 'upload0',
          type: 'proveSlot'
        }
      ]
    },
    {
      formItems: [
        {
          label: '部门',
          field: 'deptName',
          type: 'default',
          isHidden: true
        },
        {
          label: '员工',
          field: 'empName',
          type: 'default',
          isHidden: true
        }
      ]
    },
    {
      formItems: [
        {
          label: '填报日期',
          field: 'applyDate',
          type: 'default',
          isHidden: true
        }
      ]
    }
  ]
}
